import React from "react";
import "./Passionate_About_Crafting.css";

const PassionateAboutCrafting = () => {
  return (
    <section className="crafting-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 crafting-content">
            <h2>
              Passionate about crafting <br />
              journeys you’ll always <span>remember</span>
            </h2>

            <p>
              We plan every journey with care, comfort, and complete support
              from start to finish.
            </p>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="row g-3 crafting-images">
              <div className="col-6">
                <div className="craft_img_wrapper">
                  <img
                    src="/assets/images/about-us/passionate_about_crafting/passionate_img1.png"
                    alt="paris"
                    className="paris"
                  />
                </div>
              </div>

              <div className="col-6">
                <div className="row g-3">
                  <div className="col-12">
                    <div className="craft_img_wrapper">
                      <img
                        src="/assets/images/about-us/passionate_about_crafting/passionate-img2.png"
                        alt="beach"
                        className="beach"
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="craft_img_wrapper">
                      <img
                        src="/assets/images/about-us/passionate_about_crafting/passionate-img3.png"
                        alt="mountain"
                        className="mountain"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PassionateAboutCrafting;
